import { AdminRouteName } from '../../../CONSTANTS';
import EquifaxReportsTableRecords from '../EquifaxReportsTableRecords';

const NotSubmittedEquifaxReports = () => (
  <EquifaxReportsTableRecords
    defaultUrl={AdminRouteName.notSubmittedEquifaxReportRoute}
    toggleStorageId="not_submitted_equifax-reports-table-col"
    optionalColumn={['createdAt']}
    optionalColumnLabelFormat={{
      createdAt: 'Date created',
    }}
    hasNameAndImage
    permissionName="can-update-rent-payment-settlement-status"
    tabStatus="NOT_SUBMITTED"
  />
);
export default NotSubmittedEquifaxReports;
